import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import Logo2 from "../../icons/Logo2.mjs";
const Drawer = ({ children, logo, altText })=>/*#__PURE__*/ jsxs("div", {
        className: "ptw-w-full",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "ptw-flex ptw-justify-between ptw-p-4",
                children: logo ? /*#__PURE__*/ jsx("img", {
                    className: "ptw-custom-logo ptw-max-h-[calc(80px-2rem)] ptw-max-w-[150px]",
                    src: logo,
                    alt: altText ?? 'Purina'
                }) : /*#__PURE__*/ jsx(Logo2, {
                    width: 150,
                    role: "img",
                    "aria-label": "Purina"
                })
            }),
            /*#__PURE__*/ jsx("div", {
                className: "-ptw-ml-[500px] ptw-h-2 ptw-w-[1000px] ptw-bg-primary-base"
            }),
            children
        ]
    });
export { Drawer };
